import React from "react"
import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	container: {
		padding: "0"
	},
	titleText: {
		fontSize: "32px",
		lineHeight: "38px",
		color: colors.gray[800]
	},
	subtitleText: {
		fontSize: "14px",
		color: colors.gray[500]
	},
	walletBalanceBadge: {
		display: "inline-flex",
		alignItems: "center",
		gap: "6px",
		marginTop: "16px",
		padding: "4px 14px",
		border: `1px solid ${colors.purple[500]}`,
		borderRadius: "20px",
		background: colors.purple[500]
	},
	walletBalanceBadgeLabel: {
		fontSize: "14px",
		fontWeight: 500,
		color: colors.gray[0]
	},
	walletBalanceBadgeValue: {
		fontSize: "14px",
		fontWeight: 700,
		color: colors.gray[0]
	},
	cardsRow: {
		display: "flex",
		gap: "16px",
		flexWrap: "wrap" as React.CSSProperties["flexWrap"]
	},
	summaryCard: {
		flex: 1,
		minWidth: "200px",
		padding: "20px 24px",
		border: `1px solid ${colors.gray[100]}`,
		borderRadius: "8px",
		background: colors.gray[0]
	},
	summaryCardHighlighted: {
		background: colors.purple[500],
		border: `1px solid ${colors.purple[500]}`,
		"& $summaryCardLabel": {
			color: colors.gray[0]
		},
		"& $summaryCardValue": {
			color: colors.gray[0]
		}
	},
	summaryCardLabel: {
		fontSize: "15px",
		fontWeight: 500,
		color: colors.gray[500],
		marginBottom: "8px"
	},
	summaryCardValue: {
		fontSize: "28px",
		fontWeight: 700,
		color: colors.gray[800]
	},
	chartSection: {
		border: `1px solid ${colors.gray[100]}`,
		borderRadius: "8px",
		padding: "24px",
		background: colors.gray[0]
	},
	chartSectionTitleContainer: {
		display: "flex",
		alignItems: "center",
		gap: "6px"
	},
	chartSectionTitle: {
		fontSize: "16px",
		fontWeight: 600,
		color: colors.gray[800]
	},
	chartSectionSubtitle: {
		fontSize: "13px",
		color: colors.gray[500],
		marginBottom: "8px"
	},
	chartSectionInfoIcon: {
		fontSize: "16px",
		cursor: "default"
	},
	tableSectionTitle: {
		fontSize: "16px",
		fontWeight: 600,
		color: colors.gray[800],
		marginBottom: "8px"
	},
	emptyState: {
		padding: "48px 24px",
		textAlign: "center" as React.CSSProperties["textAlign"],
		color: colors.gray[500]
	},
	columnHeaderIconItem: {
		display: "flex",
		alignItems: "center"
	},
	columnHeaderIcon: {
		fontSize: "14px",
		color: colors.gray[400],
		cursor: "default"
	},
	alertInfoText: {
		fontSize: "14px",
		fontWeight: 400,
		lineHeight: "20px"
	},
	exportButtonWrapper: {
		display: "flex",
		height: "100%"
	},
	exportButtonStretch: {
		height: "100%"
	},
	selectedRow: {
		background: colors.purple[100],
		transition: "background 0.3s"
	},
	normalRow: {
		transition: "background 0.3s"
	}
})

export default useStyles
